import { render, staticRenderFns } from "./girdCom.vue?vue&type=template&id=25cf8e8f&"
import script from "./girdCom.vue?vue&type=script&lang=js&"
export * from "./girdCom.vue?vue&type=script&lang=js&"
import style0 from "./girdCom.vue?vue&type=style&index=0&id=25cf8e8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports